class GroupRouter extends App.Routers.BaseRouter {
    objGroupName = '';
    idGroup = '';
    lookupList = null;

    constructor() {
        const entityName = 'Group';
        const model = App.Models.Group;
        const collectionClass = App.Collections.Groups;

        super(entityName, model, collectionClass);
    }

    /**
     * Organization é obrigatória para cadastro pelo Live, mas pela
     * API, os grupos de sistema, podem ser criados sem essa informacao.
     * Por isso,
     * create: mandatory = true
     * edit: mandatory = false
     */

    afterCreateForm = () => {
        App.Forms.Group.form.fields.organization.setMandatory(true);
    }

    afterPopulateForm = () => {
        App.Forms.Group.form.fields.organization.setMandatory(false);
    }
}

App.Routers.Group = GroupRouter;